// State of the product modal. Comes from user interactions.
import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => ({
    productModalOpen: false,
    currentProductId: 0,
    modalAccessedFromStoreList: false,
    originalStoreCartItemIndex: -1,
    currentStoreCartItemIndex: -1,
});

export const slice = createSlice({
    name: "productModalState",
    initialState: getInitialState(),
    reducers: {
        setProductModalOpen: (state, action) => {
            const {
                productModalOpen,
                currentProductId,
                modalAccessedFromStoreList,
            } = action.payload;

            state.productModalOpen = productModalOpen;
            state.currentProductId = currentProductId;
            state.modalAccessedFromStoreList = modalAccessedFromStoreList;
        },
        updateCurrentStoreCartItemIndex: (state, action) => {
            state.currentStoreCartItemIndex = action.payload;
        },
        updateOriginalStoreCartItemIndex: (state, action) => {
            state.originalStoreCartItemIndex = action.payload;
        },
    },
});

// actions
export const {
    setProductModalOpen,
    updateCurrentStoreCartItemIndex,
    updateOriginalStoreCartItemIndex,
} = slice.actions;

// selectors
export const selectAllProductModal = (state) => state.productModalState;

export const selectCurrentProductId = (state) =>
    state.productModalState.currentProductId;

export default slice.reducer;
